// import customSelect from 'custom-select'
import customSelect from '../custom-select/index'
import { DOMAnimations } from '../libs/dom'

export default class Select {
  constructor() {
    this.init()
    this.open()
  }

  init() {
    this.customSelect = customSelect(document.querySelector('.js-select'))[0]

    const link = document.querySelector('.js-select__link')
    const selectBox = document.querySelector('.custom-select-panel')

    this.customSelect?.select.addEventListener('change', (e) => {
      link.setAttribute('href', e.target.value)
      DOMAnimations.slideToggle(selectBox)
      link.click()
    })

    document.addEventListener('click', (e) => {
      if (!e.target.closest('.custom-select-container')) {
        DOMAnimations.slideUp(selectBox)
      }
    })
  }

  open() {
    this.selectOpener = document.querySelector('.custom-select-opener')
    const selectBox = document.querySelector('.custom-select-panel')

    this.selectOpener?.addEventListener('click', () => {
      DOMAnimations.slideToggle(selectBox)
    })
  }
}
